/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Create_TitleInputs */

const cs_client_create_title = /** @type {(inputs: Client_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový klient`)
};

const en_client_create_title = /** @type {(inputs: Client_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New client`)
};

/**
* | output |
* | --- |
* | "New client" |
*
* @param {Client_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_create_title = /** @type {((inputs?: Client_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_create_title(inputs)
	return cs_client_create_title(inputs)
});